<div class="h-full min-h-0 overflow-y-auto p-4">
  <app-filtros-reporte>
    <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-person"></i>
            Empleado
          </label>
          <app-select
            class="w-full"
            [options]="opcionesEmpleado()"
            [formField]="$any(filtroForm.empleado)"
            (onChange)="aplicarFiltros()"
            placeholder="Todos los empleados"
          />
        </div>
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-arrow-left-right"></i>
            Estado
          </label>
          <app-select
            class="w-full"
            [options]="estadoOptions"
            [formField]="$any(filtroForm.estado)"
            (onChange)="aplicarFiltros()"
            placeholder="Todas"
          />
        </div>
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-calendar"></i>
            Desde
          </label>
          <app-datepicker
            class="w-full"
            [formField]="$any(filtroForm.fecha_desde)"
            (onSelect)="aplicarFiltros()"
            placeholder="dd/mm/aa"
            dateFormat="dd/mm/yy"
          />
        </div>
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-calendar"></i>
            Hasta
          </label>
          <app-datepicker
            class="w-full"
            [formField]="$any(filtroForm.fecha_hasta)"
            (onSelect)="aplicarFiltros()"
            placeholder="dd/mm/aa"
            dateFormat="dd/mm/yy"
          />
        </div>
        <div class="sm:col-span-2 lg:col-span-4">
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-search"></i>
            Dispositivo / Navegador
          </label>
          <div class="flex gap-2">
            <input
              [formField]="$any(filtroForm.dispositivo)"
              placeholder="Buscar por dispositivo o navegador..."
              class="flex-1 w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              (keyup.enter)="aplicarFiltros()"
            />
            <app-button
              label="Buscar"
              icon="bi bi-search"
              variant="info"
              (onClick)="aplicarFiltros()"
            />
            <app-button
              label="Limpiar"
              icon="bi bi-x"
              variant="secondary"
              (onClick)="limpiarFiltros()"
            />
          </div>
        </div>
      </div>
    </form>
  </app-filtros-reporte>

  <app-tabla
    [datos]="sesiones()"
    [columnas]="columnas"
    [loading]="loading()"
    [accionesTemplate]="acciones"
  >
    <ng-template #acciones let-row>
      @if (row.estado_activo) {
        <div class="flex gap-1 justify-center">
          <app-button
            icon="bi bi-x-circle"
            variant="danger"
            [rounded]="true"
            (onClick)="revocarSesion(row)"
            appTooltip="Revocar esta sesion"
            tooltipPosition="left"
          />
          <app-button
            icon="bi bi-shield-x"
            variant="warning"
            [rounded]="true"
            (onClick)="confirmarRevocarTodasUsuario(row)"
            appTooltip="Revocar todas las sesiones de este usuario"
            tooltipPosition="left"
          />
        </div>
      }
    </ng-template>
  </app-tabla>

  @if (total() > limit()) {
    <div class="flex items-center justify-between mt-4 text-sm text-slate-500">
      <span>{{ total() }} sesiones</span>
      <div class="flex gap-2">
        <app-button
          icon="bi bi-chevron-left"
          variant="secondary"
          [disabled]="page() <= 1"
          (onClick)="cambiarPagina(-1)"
        />
        <span class="py-2">{{ page() }} / {{ maxPage() }}</span>
        <app-button
          icon="bi bi-chevron-right"
          variant="secondary"
          [disabled]="page() >= maxPage()"
          (onClick)="cambiarPagina(1)"
        />
      </div>
    </div>
  }

  <app-dialog
    header="Revocar sesion"
    [modal]="true"
    [visible]="modalRevocar()"
    (visibleChange)="modalRevocar.set($event)"
    size="xs"
    styleClass="max-w-[400px]"
  >
    <p class="text-slate-600 mb-4">
      Se revocara la sesion. El usuario debera iniciar sesion nuevamente.
    </p>
    <div class="flex justify-end gap-2">
      <app-button
        label="Cancelar"
        variant="secondary"
        (onClick)="modalRevocar.set(false)"
      />
      <app-button label="Revocar" variant="danger" (onClick)="confirmarRevocar()" />
    </div>
  </app-dialog>

  <app-dialog
    header="Revocar todas las sesiones"
    [modal]="true"
    [visible]="modalRevocarTodas()"
    (visibleChange)="modalRevocarTodas.set($event)"
    size="xs"
    styleClass="max-w-[400px]"
  >
    <p class="text-slate-600 mb-4">
      Se revocaran todas las sesiones del usuario
      <strong>{{ usuarioRevocarTodas()?.usuario }}</strong
      >. Debera iniciar sesion nuevamente.
    </p>
    <div class="flex justify-end gap-2">
      <app-button
        label="Cancelar"
        variant="secondary"
        (onClick)="modalRevocarTodas.set(false)"
      />
      <app-button label="Revocar todas" variant="danger" (onClick)="confirmarRevocarTodas()" />
    </div>
  </app-dialog>
</div>
